import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ─────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────
const PAGE_W = 595.28;
const MARGIN = 20;
const CONTENT_W = PAGE_W - MARGIN * 2;
const FONT = "courier";

// ─────────────────────────────────────────────
// DRAW HEADER
// ─────────────────────────────────────────────
function drawHeader(doc, y, date) {
  const cx = PAGE_W / 2;

  // ── Company name ──────────────────────────────────────────────────────────
  doc.setFont(FONT, "bold");
  doc.setFontSize(13);
  const companyLines = doc.splitTextToSize(
    "Chamarajanagar District Co operative Milk Producers Union (CHAMUL),",
    CONTENT_W,
  );
  companyLines.forEach((line) => {
    doc.text(line, cx, y, { align: "center" });
    y += 15;
  });

  // ── Address / GSTIN ───────────────────────────────────────────────────────
  doc.setFont(FONT, "normal");
  doc.setFontSize(9);
  doc.text(
    "Kuderu Village, Santhemarahalli Hobli, Chamarajanagar Dist, Karnataka -571316, Mob: 08226 – 234848",
    cx,
    y,
    { align: "center" },
  );
  y += 12;
  doc.text("GSTIN: 29AACAC2089A1Z1", cx, y, { align: "center" });
  y += 12;

  // ── Invoice label (centered & properly spaced) ─────────────────────
  doc.setLineWidth(1);
  doc.line(MARGIN, y, PAGE_W - MARGIN, y);

  const titleBoxHeight = 22;
  doc.line(MARGIN, y + titleBoxHeight, PAGE_W - MARGIN, y + titleBoxHeight);

  doc.setFont(FONT, "bold");
  doc.setFontSize(12);

  const centerY = y + titleBoxHeight / 2 + 4;

  doc.text(`TRANSACTION DETAIL (${date})`, MARGIN + CONTENT_W / 2, centerY, { align: "center" });

  y += titleBoxHeight + 10;

  return y;
}

// ─────────────────────────────────────────────
// MAIN EXPORT
// ─────────────────────────────────────────────
export function generateTransactionDetailPDF(data = [], date = "", options = {}) {
  const {
    download = false,
    filename = `Transaction_Detail_${Date.now()}.pdf`,
    onStart,
    onFinish,
  } = options;

  if (!data?.length) return;
  onStart?.();

  const columns = [
    { title: "Sl. No", dataIndex: "sl_no", align: "center" },
    { title: "Time", dataIndex: "TIME", align: "center" },
    { title: "Amount", dataIndex: "AMOUNT", align: "center" },
    { title: "Status", dataIndex: "STATUS", align: "center" },
    { title: "Payment ID", dataIndex: "PAYMENT_ID", align: "center" },
    { title: "Bank Ref. No.", dataIndex: "BANK_REF_NO", align: "center" },
    { title: "Mode", dataIndex: "PAYMENT_MODE", align: "center" },
  ];

  try {
    const doc = new jsPDF({
      unit: "pt",
      format: "a4",
      orientation: "portrait",
    });
    let y = MARGIN;

    y = drawHeader(doc, y, date);

    const head = [columns.map((col) => col.title)];
    const body = data.map((row, index) =>
      columns.map((col) => {
        if (col.dataIndex === "sl_no") return String(index + 1);
        const val = row[col.dataIndex];
        return val !== undefined && val !== null ? String(val) : "";
      }),
    );

    autoTable(doc, {
      head,
      body,
      startY: y,
      margin: { left: MARGIN, right: MARGIN },
      tableWidth: CONTENT_W,
      styles: {
        font: FONT,
        fontSize: 9,
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.3,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        minCellHeight: 20,
      },
      columnStyles: columns.reduce((acc, col, idx) => {
        acc[idx] = { halign: col.align || "center" };
        return acc;
      }, {}),
      didParseCell(cellData) {
        if (cellData.section === "body") {
          cellData.cell.styles.fillColor = [255, 255, 255];
          if (columns[cellData.column.index].dataIndex === "STATUS") {
            const status = cellData.cell.raw;
            if (status === "SUCCESS") {
              cellData.cell.styles.textColor = [0, 128, 0];
              cellData.cell.styles.fontStyle = "bold";
            } else if (status === "FAILED") {
              cellData.cell.styles.textColor = [255, 0, 0];
              cellData.cell.styles.fontStyle = "bold";
            }
          }
        }
      },
      theme: "grid",
    });

    if (download) {
      doc.save(filename);
    } else {
      window.open(URL.createObjectURL(doc.output("blob")));
    }

    const base64PDF = doc.output("datauristring").split(",")[1];

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "download_pdf",
          fileName: filename,
          base64: base64PDF,
        }),
      );
    }
  } catch (err) {
    console.error("Transaction Detail PDF generation error:", err);
  } finally {
    onFinish?.();
  }
}
